<template lang="pug">
app-page(:fabItems="fabItems" title="Управление пользователями" :loading="loading" @search="text => (search = text.toLowerCase())")
  app-toolbar(:title="'Список пользователей'")
    app-toolbar-item.ml-2(label="Роль" :items="grantsItems" all="все" key-name="titleRu" min-width="120" @select="selectRole") {{ selectedRole ? selectedRole.titleRu : "все" }}

  .text-right
    v-chip.ma-2(v-if="search" color="#757575" text-color="white" small label close @click:close="search = null") Поиск:&nbsp;<b>{{ search }}</b>
    v-chip.ma-2(v-if="selectedRole" color="#757575" text-color="white" small label close @click:close="selectRole(null)") Поиск:&nbsp;<b>{{ selectedRole.titleRu }}</b>

  app-group-animation
    app-group-item(v-for="(u, index) in listUsers" :key="index" cols="4")
      app-card(@click.native="showUser(u)" data-aos="fade-top")
        app-card-header 
          app-card-title(v-html="userLogin(u.login)")
        app-card-body
          app-card-headline(v-html="userFIO(u.fio)")
          app-card-caption Роли:
          app-card-caption(v-line-clamp="1")
            span(v-for="(g, index2) in u.grants" :key="index2") {{ getGrantType(g.grantType) }} 
              span(v-if="index2 < u.grants.length-1") 
                |  ,

  app-dialog(v-model="dialog.userCreate" header="Добавить пользователя")
    v-form(ref="newUserForm")
      app-text-field(v-model="form.user.login" :rules="[rules.required]" label="Логин")
      app-text-field(v-model="form.user.fio" :rules="[rules.required]" label="ФИО")
      app-text-field(v-model="form.user.phone" label="Телефон")
      app-text-field(v-model="form.user.email" label="E-mail")
      app-text-field(
        v-model="form.user.password" 
        :rules="[rules.required]" 
        :append-icon="showPSWD ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPSWD ? 'text' : 'password'"
        @click:append="showPSWD = !showPSWD"
        label="Пароль")
      app-select(v-model="form.user.grants" :items="grantsItems" item-text="titleRu" item-value="title" :rules="[rules.requiredcombo]" label="Выбрать роль" multiple)
      div(v-if="showSelectJudges()")
        app-select(v-model="form.user.objId" :items="judges" :rules="[rules.requiredcombo]" label="Выбрать судью" item-text="lastName" item-value="id")

      app-button-action(@click="addUser()") добавить

    app-dialog(v-model="dialog.error" header="Уведомление об ошибке")
      | {{ textError }}
</template>

<script>
import { userService } from "@/_services";
import { AppDialogConfirm } from '@/components'
import { mapGetters, mapMutations, mapState } from 'vuex'
import { $_validate_rules } from '@/common/ValidateRules'

export default {
  mixins: [$_validate_rules],

  components: {
    [AppDialogConfirm.name]: AppDialogConfirm,
  },

  data () {
    return {
      search: null,
      textError: "",
      showPSWD: false,
      dialog: {
        userCreate: false,
        error: false
      },
      form: {
        user: {
          login: '',
          password: '',
          fio:'',
          phone:'',
          email:'',
          grants: [],
          objId: '',
        }
      }
    }
  },

  computed: {
    ...mapGetters('users', ['grants', 'users', 'isUsersLoaded', 'judges']),
    ...mapState('users', ['selectedRole', 'currentUser']),

    loading () {
      return !this.isUsersLoaded
    },

    grantsItems () {
      return this.grants.filter(grant => grant.name != 'SPECIALIST')
    },

    fabItems () {
      return [
        { icon:'add', title:'Добавить пользователя', action: () => this.userCreate () },
      ]
    },

    listUsers () {
      let list = this.users
      if (this.selectedRole && this.selectedRole.titleRu.indexOf("все") == -1) {
        list = list.filter(u => u.grants.find(g => g.grantType == this.selectedRole.title))
      }
      if (this.search) {
        list = list.filter(item => 
          item.login.toLowerCase().includes(this.search) || 
          (item.fio && item.fio.toLowerCase().includes(this.search))
        )
      }
      list = list.sort((a, b) => a.login.localeCompare(b.login))
      return list
    }
  },

  methods: {
    ...mapMutations('users', ['setCurrentUser', 'setUserInUsers', 'selectRole']),

    userLogin (login) {
      return login ? this.searchText(login) : ''
    },

    userFIO (fio) {
      return fio ? this.searchText(fio) : 'ФИО не заполнено'
    },

    searchText (str) {
      if (!this.search || this.search.length == 0 ) {
        return str
      }
      return str.replace(new RegExp(this.search, "gi"), match => {
        return `<span style="color: #00BCD4; margin: 0px 1px;">${match}</span>`
      })
    },

    getGrantType (grant) {
      return this.grants.find(g => g.title == grant).titleRu
    },

    userCreate () {
      // this.$store.dispatch('users/LOAD_JUDGES')
      return this.dialog.userCreate = true
    },

    showSelectJudges () {
      if (this.form.user.grants.find(item => item.indexOf("JUDGE")!=-1 || item.indexOf("JUDGEHELPER")!=-1))
        return true
      return false
    },

    isNull (text) {
      return text ? text : ''
    },

    addUser () {
      if (this.$refs.newUserForm.validate()) {
        let grants = []
        this.form.user.grants.map(grant => {
          let grantObj = {
            "id": 0,
            "grantType": grant,
            "location": "",
            "locationObj": "" + this.form.user.objId
          }
          grants.push(grantObj)
        })
        
        userService.userAdd(this.form.user).then(data => {
          let status = ["error", "denied", "exist"]
          if (status.includes(data)) {
            this.dialog.error = true
            if (data == "error") this.textError = "Ошибка авторизации"
            if (data == "denied") this.textError = "Пользователь не найден"
            if (data == "exist") this.textError = "Такой пользователь уже существует"
          }
          else {
            let obj = {
              "id": data,
              "uuid": data,
              "login": this.form.user.login,
              "fio": this.form.user.fio,
              "phone": this.form.user.phone,
              "email": this.form.user.email,
              "password": null,
              "grants": grants
            }
            this.setUserInUsers(obj)
          }
          this.dialog.userCreate = false 
        })
      }
    },

    showUser(user) {
      this.setCurrentUser(user)
      this.$router.push({ path: `/admin/users/${user.id}` })
    },
  },

  mounted () {
    this.$store.commit('setInUsers', true)
    this.$store.dispatch('users/INIT')
  },

  beforeDestroy() {
    this.$store.commit('setInUsers', false)
  }
}
</script>